var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.getters.loadCompleted)?_c('router-view'):_vm._e(),_c('loading'),_c('notice'),_c('request'),_c('commercial'),(_vm.$store.getters.loadCompleted)?_c('cookie-agree'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }